import { usePricingData } from '@pkg/hooks';

import { SupportedTokens } from '@app/client';
import { type FreshCollection, useFantasyCollectionMetadataStore, useFantasyFreshDataBoard } from '@app/store/zustand';

export function useAddFreshCollection() {
    const { setCollectionsMetadata } = useFantasyCollectionMetadataStore();
    const { addCollectionsToBatch } = useFantasyFreshDataBoard();
    const getPricingData = usePricingData();

    return async (collectionData?: FreshCollection[], chainProp?: SupportedTokens) => {
        const slugs = collectionData?.map((item) => item.slug).filter((slug) => !!slug);
        if (chainProp) {
            setCollectionsMetadata({ [SupportedTokens[chainProp]]: collectionData });
        }
        if (slugs?.length) {
            const pricingData = await getPricingData({
                slugs,
                days: 24,
                chain: chainProp,
            });
            const volumeResponse = pricingData?.salesVolumes;
            const floorPriceChangesRes = pricingData?.floorPriceChanges;

            const completeCollections = collectionData?.map((collection) => {
                const salesVolume = volumeResponse?.find((sv) => sv.collection === collection.slug);
                const floorPriceChange = floorPriceChangesRes?.find((res) => res.slug === collection.slug) || undefined;

                return {
                    ...collection,
                    salesVolume,
                    floorPriceChange,
                };
            });

            if (completeCollections?.length) {
                addCollectionsToBatch(completeCollections);
            }
        }
    };
}
